/** 配置开关解析：'1'=开启，'0'/空串/缺失=未开启 */
export function isEnabled(v?: string | null): boolean {
  return v === '1'
}

/** 配置数值解析：非法/缺失返回默认值 */
export function toInt(v: string | number | null | undefined, def = 0): number {
  const n = Number.parseInt(String(v ?? ''), 10)
  return Number.isNaN(n) ? def : n
}

/** 热词解析：英文逗号分隔，最多 limit 个 */
export function splitHotWords(v?: string | null, limit = 5): string[] {
  if (!v)
    return []
  return v
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .slice(0, limit)
}

/** 模拟网络延迟 */
export function delay(ms = 400): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms))
}

/** 生成唯一 id */
export function genId(prefix = 'id'): string {
  return `${prefix}_${Date.now()}_${Math.floor(Math.random() * 100000)}`
}

/** 格式化时间为 YYYY-MM-DD HH:mm:ss */
export function formatTime(date: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

/**
 * 弱密码黑名单（与后端同一套校验器，26 个；如后端调整需同步）
 */
export const WEAK_PASSWORDS = [
  '12345678', '123456789', '1234567890', '1234567891', '12345678123456',
  '11111111', '00000000', '88888888', '66666666', '99999999',
  '12341234', '1234321', '11223344', '147258369', '987654321',
  'admin123', 'admin888', 'admin1234', 'root1234', 'test1234',
  'password1', 'password123', 'qwerty123', 'abc123456', 'abcd1234',
  '1qaz2wsx',
]

/**
 * 新版密码规则校验（注册/自助改密/管理端重置共用同一套）：
 * 1. 长度 8~20 位
 * 2. 大写/小写/数字/特殊字符至少 3 种
 * 3. 不能与账号相同（不区分大小写）
 * 4. 不能是账号逆序
 * 5. 不能有 3 个及以上连续重复字符（aaa、111）
 * 6. 不能命中弱密码黑名单
 * @returns null=通过，否则返回错误提示
 */
export function validateNewPassword(password: string, account = ''): string | null {
  if (password.length < 8 || password.length > 20)
    return '密码长度须为 8~20 位'

  const types = [
    /[a-z]/.test(password),
    /[A-Z]/.test(password),
    /[0-9]/.test(password),
    /[^A-Za-z0-9]/.test(password),
  ].filter(Boolean).length
  if (types < 3)
    return '密码须包含大写字母、小写字母、数字、特殊字符中至少 3 种'

  const acc = account.trim().toLowerCase()
  if (acc) {
    if (password.toLowerCase() === acc)
      return '密码不能与账号相同'
    if (password.toLowerCase() === acc.split('').reverse().join(''))
      return '密码不能是账号的逆序'
  }

  if (/(.)\1\1/.test(password))
    return '密码不能包含 3 个及以上连续重复字符（如 aaa、111）'

  if (WEAK_PASSWORDS.includes(password.toLowerCase()))
    return '密码过于简单，请更换'

  return null
}

/** 去除字符串中的 HTML 标签（后端部分字段会混入富文本） */
export function stripHtml(str = ''): string {
  return String(str)
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .trim()
}

/** 生成订单号 */
export function genOrderNo(): string {
  const now = new Date()
  const pad = (n: number) => String(n).padStart(2, '0')
  const rand = Math.floor(Math.random() * 9000) + 1000
  return `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}${rand}`
}
